<template>
  <div class="m-0 search-container">
    <b-input-group class="input-group-merge">
      <b-input-group-prepend is-text class="add-on-search-border">
        <feather-icon icon="SearchIcon" />
      </b-input-group-prepend>
      <b-form-input
        class="d-inline-block add-on-border-search-input"
        placeholder="Search..."
        @input="onSearchInput"
      />
    </b-input-group>
  </div>
</template>

<script>
import { BInputGroup, BInputGroupPrepend, BFormInput } from "bootstrap-vue";
export default {
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
  },
  props: {
    onSearchInput: { type: Function, default: function () {} },
  },
};
</script>

<style scoped>
.search-container {
  width: 100% !important;
}

.add-on-border-search-input {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

.add-on-search-border > div {
  border-radius: 12px;
}

.search-input {
  width: 200px;
  transition: width 0.3s ease-in-out;
}
.search-input:focus {
  width: 300px;
}
</style>
